import { render, staticRenderFns } from "./QueryInsuredMenu.vue?vue&type=template&id=4522f639&"
import script from "./QueryInsuredMenu.vue?vue&type=script&lang=js&"
export * from "./QueryInsuredMenu.vue?vue&type=script&lang=js&"
import style0 from "./QueryInsuredMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports